import React from 'react'
import { Popconfirm } from 'antd'
import { useDispatch, useSelector } from 'react-redux'

import CustomButton from '../../../../components/ButtonCustom'

import { appealsActions } from '../../store/actions'

import i18n from '../../localization'

const TakeIntoAccount = ({ id }) => {
    const isRu = useSelector((state) => state.globalReducer.isRu)
    const { takeIntoAccountLoading } = useSelector(state => state.appealsReducer)

    const dispatch = useDispatch()

    const takeIntoAccount = () => {
        dispatch(appealsActions.takeIntoAccount({ id }))
    }

    return (
        <Popconfirm
            cancelText={i18n.no[isRu]}
            okText={i18n.yes[isRu]}
            title={i18n.takeIntoAccountPopconfirm[isRu]}
            onCancel={() => {
                return null
            }}
            onConfirm={() => takeIntoAccount()}>
            <CustomButton
                type="orange"
                loading={takeIntoAccountLoading}>
                {i18n.takeIntoAccount[isRu]}
            </CustomButton>
        </Popconfirm>
    )
}

export default TakeIntoAccount